export const GET_ADDRESSES = "GET_ADDRESSES";
export const SAVE_ADDRESS = "SAVE_ADDRESS";
export const EDIT_ADDRESS = "EDIT_ADDRESS";
export const DELETE_ADDRESS = "DELETE_ADDRESS";

export const SET_DEFAULT = "SET_DEFAULT";
export const SET_DELIVERY_ADDRESS = "SET_DELIVERY_ADDRESS";
export const SET_TAX_ADDRESS = "SET_TAX_ADDRESS";
export const SET_ADDRESS_ID = "SET_ADDRESS_ID";
export const SET_TAX_ID = "SET_TAX_ID";